import { graphql } from "@opensea/graphql"

export const CreateOfferPriceWarningModal_itemFragment = graphql(`
  fragment CreateOfferPriceWarningModal_item on Item {
    bestListing {
      pricePerItem {
        token {
          unit
        }
      }
    }
    bestOffer {
      pricePerItem {
        token {
          unit
        }
      }
    }
    chain {
      offerCurrency {
        symbol
      }
      listingCurrency {
        symbol
      }
    }
  }
`)
